import { ListingProperties } from "../../types/listing.type";
import { TransferListingItem } from "./Create";

export const generateAllCheckState = (listings?: TransferListingItem[]) => {
	if (listings && listings.length > 0) {
		let checkedList = listings.filter((item) => item.checked);
		if (checkedList.length === 0) {
			return {
				checked: false,
				indeterminate: false,
			};
		}
		if (checkedList.length === listings.length) {
			return {
				checked: true,
				indeterminate: false,
			};
		}
		if (checkedList.length < listings.length) {
			return {
				checked: true,
				indeterminate: true,
			};
		}
	}
	return {
		checked: false,
		indeterminate: false,
	};
};
export const doFilterItem = (
	item: TransferListingItem | ListingProperties,
	searchFilter: string,
	typeFilter: string
) => {
	if (!item) return true;
	if (!searchFilter && !typeFilter) return true;

	let filter1 = true;
	let filter2 = true;
	if (searchFilter) {
		filter1 =
			(item.title?.toLowerCase().includes(searchFilter.toLowerCase()) ||
				item.listingCode?.toLowerCase().includes(searchFilter.toLowerCase()) ||
				(item as TransferListingItem).agent?.name?.toLowerCase().includes(searchFilter.toLowerCase()) ||
				[item.streetName, item.city]
					.filter(Boolean)
					.join(", ")
					?.toLowerCase()
					.includes(searchFilter.toLowerCase())) ??
			false;
	}
	if (typeFilter) {
		filter2 = item.listingType === typeFilter;
	}

	return filter1 && filter2;
};
